import React, { useEffect, useRef, useState } from 'react'
import { css } from '@emotion/core'
import useEventListener from '../../../shared/hooks/useEventListener'

const distributeChildren = (children, columnCount) => {
  const childArray = React.Children.toArray(children)
  if (!childArray.length || columnCount <= 0) return []

  const columns = [...Array(columnCount)].map(() => [])
  childArray.forEach((child, index) => columns[index % columnCount].push(child))
  return columns
}

// Masonry view with CSS Grid - Special Thanks to Janosh Riebesell
// https://janosh.dev/blog/react-hooks-masonry
export default function Masonry({ children, gap, minWidth = 500, columnCount, ...rest }) {
  const ref = useRef()
  const [numColumns, setNumColumns] = useState(columnCount)
  const columns = distributeChildren(children, numColumns)

  const masonryContainer = css`
    display: grid;
    grid-template-columns: repeat(${numColumns}, 1fr);
    grid-auto-flow: column;
    grid-gap: ${gap};
  `

  const masonryColumn = css`
    display: grid;
    align-content: start;
    grid-gap: ${gap};
  `

  const resizeHandler = () => {
    if (ref?.current?.offsetWidth) {
      setNumColumns(Math.ceil(ref.current.offsetWidth / minWidth))
    }
  }
  useEffect(resizeHandler, [minWidth])
  useEventListener(`resize`, resizeHandler)

  return (
    <div css={masonryContainer} ref={ref} gap={gap} {...rest}>
      {columns?.map((column, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div css={masonryColumn} key={`column_${index}`}>
          {column}
        </div>
      ))}
    </div>
  )
}
